module.exports = __webpack_public_path__ + "img/stain.a4f1298f.jpg";